// @flow
import { connect } from "react-redux";

import PageHeaderView from "./view";
import { search, showBlog } from "../state/blogs/actions";

export default connect(
    state => ({
        session: state.context.sessionInfo,
        userInfo: state.context.userInfo,
        searchResults: state.blogs.searchResults
    }),
    dispatch => ({
        onSearch: searchTerm => dispatch(search(searchTerm)),
        onShowBlog: blog => dispatch(showBlog(blog))
    })
)(PageHeaderView);



// WEBPACK FOOTER //
// ./src/header-view/index.js